"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("@hotmart/cosmos/dist/tag");
require("@hotmart/cosmos/dist/tag/variations/blue.css");
require("@hotmart/cosmos/dist/tag/variations/cyan.css");
require("@hotmart/cosmos/dist/tag/variations/green.css");
require("@hotmart/cosmos/dist/tag/variations/large.css");
require("@hotmart/cosmos/dist/tag/variations/purple.css");
require("@hotmart/cosmos/dist/tag/variations/red.css");
require("@hotmart/cosmos/dist/tag/variations/small.css");
require("@hotmart/cosmos/dist/tag/variations/yellow.css");
const Tag = ({ children, variation = 'default', size = 'md', className, onDismiss, dismissButtonLabel = '', ...props }) => {
    const ref = (0, react_1.useRef)();
    const classes = (0, classnames_1.default)(className, {
        [`hot-tag--${variation}`]: variation,
        [`hot-tag--${size}`]: size
    });
    (0, react_1.useEffect)(() => {
        const current = ref.current;
        const handler = () => onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
        current === null || current === void 0 ? void 0 : current.addEventListener('dismiss', handler);
        return () => {
            current === null || current === void 0 ? void 0 : current.removeEventListener('dismiss', handler);
        };
    }, [onDismiss]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        const dismissButton = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.hot-tag__close');
        dismissButton === null || dismissButton === void 0 ? void 0 : dismissButton.setAttribute('role', 'button');
        dismissButton === null || dismissButton === void 0 ? void 0 : dismissButton.setAttribute('aria-label', dismissButtonLabel);
    }, [dismissButtonLabel]);
    return ((0, jsx_runtime_1.jsx)("hot-tag", { class: classes, ref: ref, ...(onDismiss && { dismissible: true }), ...props, children: children }));
};
exports.default = Tag;
